import type { CloudGraphCommentEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI: CloudGraphCommentEntityAti[] = [
	'ati:cloud:graph:comment',
];
